import React, {useState, useRef, Component} from "react";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import {graphql} from "gatsby";
import Slider from "react-slick";
import StructuredText from "../custom-structured-text-renderer";
import parse from "html-react-parser";

const Testimonial = ({title, items, reverse, theme}) => {
  const [dot, setDot] = useState(0)
  const sliderRef = useRef(null)

  const settings = {
    className: "slider variable-width",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    fade: !theme,
    dots: !!theme,
    centerMode: !!theme,
    variableWidth: !!theme,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: dots => <ul className='dots'>{dots}</ul>,
    customPaging: i => (<div className='dots__item'></div>),
    beforeChange: (current, next) => {
      setDot(next)
    },
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
          autoplay: true,
          autoplaySpeed: 5000,
        }
      },
    ]
  }

  const dotClick = (index) => {
    if (sliderRef?.current) {
      sliderRef?.current?.slickGoTo(index);
    }
  }

  return (
    <section className={`testimonial ${theme || ''}`}>
      <div className='testimonial__inner'>
        {theme && title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
        <div className={`testimonial__items`} data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          <Slider {...settings} ref={sliderRef}>
            {
              items?.length > 0 && items.map((el, i, arr) => {
                // first letter of el.name
                let initialLetter = el.name?.charAt(0)
                return (
                  <div key={i}
                      className={`testimonial__item ${!theme && reverse ? 'testimonial__item-reverse' : ''}`}>
                    <div className='testimonial__item-content'>
                      {el.quote && <StructuredText as='h3' data={el.quote}/>}
                      <div className='testimonial__item-avatar'>
                        {theme && 
                          <div className='testimonial__item-avatar-icon'>
                            <span>{initialLetter}</span>
                          </div>
                        }
                        <div>
                          {el.name && <p>{el.name}</p>}
                          {el.business && <p>{el.business}</p>}
                        </div>
                      </div>
                      {
                        !theme && items.length > 0 &&
                        <ul className='testimonial__dots'>
                          {Array.from({length: arr.length}, (dotEl, d) => (
                            <li key={d}>
                              <div onClick={() => dotClick(d)}
                                  className={`testimonial__dots-item ${d === dot ? 'active' : ''}`}></div>
                            </li>
                          ))}
                        </ul>
                      }
                    </div>

                    <div className='testimonial__item-image'>
                      {el.image && <Asset asset={el.image}/>}
                    </div>
                  </div>
                )
              })
            }
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default Testimonial

export const query = graphql`
fragment TestimonialProps on DatoCmsTestimonial {
  ... on DatoCmsTestimonial {
    id
    title
    reverse
    items {
      quote {
        value
      }
      business
      name
      icon {
        ...InternalAssetProps
      }
      image {
        ...InternalAssetProps
      }
    }
  }
}
`